import React from "react";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { useLocation } from "react-router-dom";

const Footer = () => {

  const location = useLocation();
  const isCVPage = location.pathname === "/cv";

  const quickLinks = [
    { name: "Home", link: "/#home" },
    { name: "Services", link: "/#services" },
    { name: "Portfolio", link: "/#portfolio" },
    { name: "Our Team", link: "/#ourteam" },
    { name: "Contact", link: "/#contactus" }
  ];

  // সোশ্যাল মিডিয়া লিংক
  const socialLinks = [
    { 
      name: "Facebook", 
      icon: FaFacebookF, 
      link: "https://www.facebook.com/pyruxsupport", // আপনার Facebook পেজের লিংক দিন
      color: "#1877F2" 
    },
    { 
      name: "Twitter", 
      icon: FaTwitter, 
      link: "https://x.com/pyruxsupport", // আপনার Twitter প্রোফাইলের লিংক দিন
      color: "#1DA1F2" 
    }
  ];

  const handleNavClick = (e, link) => {
    e.preventDefault();

    if (isCVPage) {
      window.location.href = link;
    } else {
      const elementId = link.split("#")[1];
      const element = document.getElementById(elementId);

      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  // Subscribe button popup
  const handleSubscribe = () => {
    alert("This feature are under construction. Please be patient. It will be fix soon!");
  };

  return (
    <footer
      style={{
        backgroundColor: "#111827",
        color: "#f1f5f9",
        padding: "60px 20px",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          gap: "40px",
        }}
      >
        {/* Logo & About */}
        <div style={{ flex: "1 1 250px" }}>
          <h2 style={{ fontSize: "24px", fontWeight: "700", marginBottom: "12px" }}>
            Pyrux
          </h2>
          <p style={{ fontSize: "14px", color: "#94a3b8", lineHeight: "1.6" }}>
            We create amazing digital experiences for your business. Our team
            delivers high-quality web, mobile, and design solutions to help you
            grow faster.
          </p>
        </div>

        {/* Quick Links */}
        <div style={{ flex: "1 1 150px" }}>
          <h3 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "12px" }}>
            Quick Links
          </h3>

          <ul
            style={{
              listStyle: "none",
              padding: 0,
              fontSize: "14px",
              color: "#94a3b8",
            }}
          >
            {quickLinks.map((item, index) => (
              <li key={index} style={{ marginBottom: "8px" }}>
                <a
                  href={item.link}
                  onClick={(e) => handleNavClick(e, item.link)}
                  style={{
                    color: "#94a3b8",
                    textDecoration: "none",
                    cursor: "pointer",
                    transition: "0.3s",
                  }}
                  onMouseEnter={(e) => (e.target.style.color = "#fff")}
                  onMouseLeave={(e) => (e.target.style.color = "#94a3b8")}
                >
                  {item.name}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact Info */}
        <div style={{ flex: "1 1 200px" }}>
          <h3 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "12px" }}>
            Contact Us
          </h3>
          <p style={{ fontSize: "14px", color: "#94a3b8", lineHeight: "1.6" }}>
            Email: pyruxsupport@gmail.com <br />
            Phone: +8801984831657
          </p>
        </div>

        {/* Newsletter */}
        <div style={{ flex: "1 1 250px" }}>
          <h3 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "12px" }}>
            Newsletter
          </h3>

          <p style={{ fontSize: "14px", color: "#94a3b8", marginBottom: "12px" }}>
            Subscribe to receive our latest news and updates.
          </p>

          <div style={{ display: "flex", gap: "8px" }}>
            <input
              type="email"
              placeholder="Your email"
              style={{
                flex: 1,
                padding: "10px 12px",
                borderRadius: "8px",
                border: "none",
                fontSize: "14px",
              }}
            />

            <button
              onClick={handleSubscribe}
              style={{
                padding: "10px 16px",
                borderRadius: "8px",
                backgroundColor: "#6366F1",
                color: "#fff",
                border: "none",
                cursor: "pointer",
                fontWeight: "600",
              }}
            >
              Subscribe
            </button>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div
        style={{
          borderTop: "1px solid rgba(255,255,255,0.1)",
          margin: "40px 0 20px 0",
        }}
      ></div>

      {/* Bottom */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "center",
          maxWidth: "1200px",
          margin: "0 auto",
          fontSize: "14px",
          color: "#94a3b8",
        }}
      >
        <p>© {new Date().getFullYear()} Pyrux – Global Digital Agency. Web Development, SEO & Automation Services.</p>

        {/* Social Media Links with actual URLs */}
        <div style={{ display: "flex", gap: "16px", marginTop: "10px" }}>
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.link}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#94a3b8",
                transition: "all 0.3s ease",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = social.color;
                e.currentTarget.style.transform = "translateY(-3px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = "#94a3b8";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              <social.icon size={18} />
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;